import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { pick } from '@backmarket/utils/object/pick'
import type { INPMetricWithAttribution } from 'web-vitals/attribution'

import type { PageViewData } from '../types'

const SLOW_INTERACTION_THRESHOLD = 200

/**
 * Logs slow INP (Interaction to Next Paint) metrics to Datadog.
 * Only logs events that are "needs improvement" or "poor" (>= 200ms).
 */
export function logINPAttributionToDatadog(
  metric: INPMetricWithAttribution,
  pageData: PageViewData,
): void {
  const { info } = useLogger()
  const { value: duration, attribution, id, rating, name } = metric

  if (duration < SLOW_INTERACTION_THRESHOLD) return

  const [location, targetElement] = attribution.interactionTarget.split('|')
  let longestScript
  if (metric.attribution.longestScript) {
    longestScript = pick(
      metric.attribution.longestScript.entry as unknown as Record<
        string,
        unknown
      >,
      [
        'invoker',
        'invokerType',
        'name',
        'sourceURL',
        'sourceFunctionName',
        'sourceCharPosition',
      ],
    )
  }

  const analyticsData = {
    owners: [],
    web_vitals: {
      event_name: 'web_vitals_inp',
      metric_id: id,
      metric_rating: rating,
      event_type: name,
      target_element: targetElement,
      duration,
      input_delay: Math.round(attribution.inputDelay),
      processing_duration: Math.round(attribution.processingDuration),
      presentation_delay: Math.round(attribution.presentationDelay),
      page_type: pageData.pageType,
      location,
      device_type: pageData.deviceType,
      connection: pageData.connection,
      country: pageData.country,
      longestScript,
    },
  }

  info('INP slow interaction', analyticsData)
}
